import React from 'react';
import './styles.scss';
import 'font-awesome/css/font-awesome.min.css';

const FullWidthImageCard: React.FC<any> = ({
  heading,
  headingFontColor,
  subHeading,
  ctaText,
  ctaUrl,
  desktopBgImage,
  dsktopImageAlt,
  mobileBgImage,
  mobileImageAlt,
}) => {

  return (
    <div className="container-fluid full-width-img-card-react">
      {heading || subHeading || ctaText ?
        <div className="col-12 text-center">
          {heading ? <h2 style={{color: headingFontColor}} className="dynamic-heading">{heading}</h2> : ""}
          <div className="clearfix"></div>
          {subHeading ? <h4 className="dynamic-subheading">{subHeading}</h4> : ""}
          <div className="clearfix"></div>
          {ctaText ? <a href={ctaUrl ? ctaUrl : "#"} className="btn btn-white dynamic-cta">{ctaText}</a> : ""}
        </div>
        : ""
      }
      
      {desktopBgImage ? <span className="desktop-image" style={{backgroundImage: "url("+desktopBgImage+")"}}></span> : ""}
      {mobileBgImage ? <span className="mobile-image" style={{backgroundImage: "url("+mobileBgImage+")"}}></span> : ""}
      
    </div>
  );
};

export default (FullWidthImageCard);
